import React, { useState, useContext, useEffect } from 'react'

import Pal from '../components/Pal';
import infoUpdate from '../serverPostHandling';
import ReactTyped from 'react-typed';
import StepContext from '../Contexts/StepContext';
import { useQuery } from '@tanstack/react-query';
import fetchServerResponse from '../severGetHandling';
import RadioOption from "../components/ProfileCompletionComponents/RadioOption"
import { ColorRing } from  'react-loader-spinner'

function Dashboard(props) {
 const {stepCount, incrementStepCount} = useContext(StepContext)
 const [display, setDisplay] = useState(false);
 const [radioOptionSelected, setRadioOptionSelected] = useState("");

 useEffect(()=>{
    setDisplay(false)
 }, [props]);
  
 const onSelected = (selectedValue) =>{
  setRadioOptionSelected(selectedValue);
}
 //calling useQuery
 const { data: serverGetResponse, isLoading } = useQuery(
  ["serverGetResponse", props.endpoint],
  () => fetchServerResponse(props.endpoint)
);

 const handleEnter = async(event)=>{
  event.preventDefault();
  document.getElementById('onboarding-button').disabled = true;
  if(radioOptionSelected === ""){
    alert("Please chose an option")
    return;
  }
  
  const updateResponse =await infoUpdate("response", props.label, radioOptionSelected);
  incrementStepCount();
}
 const onCompleteHandler = () =>{
  setDisplay(true);
}

const handleRadioOptions = ()=>{
 
  return props.option.map((value, index) => (
    <RadioOption value={value} onChangeFunc={onSelected} />
  ));
}

  return (
    <div className='form-container'>
        <div className= 'form-card'>
          {isLoading ? (<ColorRing
            visible={true}
            height="80"
            width="80"
            ariaLabel="blocks-loading"
            wrapperStyle={{}}
            wrapperClass="blocks-wrapper"
            colors={['#e15b64', '#f47e60', '#f8b26a', '#abbd81', '#849b87']}
          />):
          (<div className='pal-container'>
              <Pal/>
              <ReactTyped strings={[props.altcontent]} 
              typeSpeed={20} 
              onComplete={onCompleteHandler}/>
              
            </div>)
          }
          {display &&<div id = "radio-option-container" className='radio-options'>
            {handleRadioOptions()}
        </div> }
          {display && <button id='onboarding-button' className="form-submit-button" onClick={handleEnter}>Enter</button>}
        </div>
    </div>
  
  )
}

export default Dashboard